import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
const steps = ['Open the complete teaching system.', 'Explore the 6 volumes.', 'Review the 5 bonus guides.', 'Use the material in your teaching.'];
export function Guarantee() {
  return <section className="bg-blush px-4 py-20 sm:py-28" data-id="element-113" data-mp="1x4l8puyq5m4c">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto grid max-w-5xl items-center gap-10 rounded-3xl border border-champagne bg-cream-light p-8 shadow-lg sm:p-12 md:grid-cols-[auto_1fr]" data-id="element-114" data-mp="1x54pv9gjw6hb">
        <div className="mx-auto flex h-44 w-44 flex-col items-center justify-center rounded-full border-[6px] border-double border-champagne-deep bg-champagne-light text-center" role="img" aria-label="7-day guarantee badge" data-id="element-115" data-mp="1ed26hqciyc3d">
          <ShieldCheckIcon size={30} className="text-champagne-deep" aria-hidden="true" data-id="element-116" data-mp="ozrsoo32f265" />
          <span className="mt-1 font-serif text-5xl font-semibold leading-none text-espresso" data-id="element-117" data-mp="txbdy7y6kf7l">
            7
          </span>
          <span className="mt-1 text-[11px] font-bold uppercase tracking-[0.18em] text-raspberry" data-id="element-118" data-mp="yrfmgvn3gvas">
            Day Guarantee
          </span>
        </div>
        <div className="text-center md:text-left" data-id="element-119" data-mp="61fc4h9tqq0j">
          <h2 className="font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-120" data-mp="6309sfrfqp2m">
            Complete 7-Day Guarantee
          </h2>
          <ul className="mt-6 space-y-1.5 text-base leading-7 text-cocoa" data-id="element-121" data-mp="f0ak9ywfia6h">
            {steps.map(step => <li key={step} data-id="element-122" data-mp="k185kkcqjkc7">{step}</li>)}
          </ul>
          <p className="mt-5 text-base font-semibold leading-7 text-espresso" data-id="element-123" data-mp="1qh0nra9gwnwe">
            If the material is not delivered correctly or there is an issue with
            the files you receive, contact support within 7 days according to
            the guarantee terms.
          </p>
        </div>
      </motion.div>
    </section>;
}